import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import { isTokenExpired } from './utils/auth';

const PrivateRoute: React.FC = () => {
  const { state } = useAuth();

  if (!state.token || isTokenExpired(state.token)) {
    // Drop any stale/expired session so requests don't keep sending a dead token.
    if (state.token) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};

export default PrivateRoute;
